/**
 * @generated SignedSource<<7ac999ca45354d007affb47cdaf56d08>>
 * @relayHash 199e0f4b56ff95d528e0b598ff7d46ea
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 199e0f4b56ff95d528e0b598ff7d46ea

import { ConcreteRequest } from 'relay-runtime';
export type De_signTherapyPrescriptionDocumentInput = {
  id: string;
};
export type useDeSignTherapyPrescriptionMutation$variables = {
  input: De_signTherapyPrescriptionDocumentInput;
};
export type useDeSignTherapyPrescriptionMutation$data = {
  readonly de_signTherapyPrescriptionDocument: {
    readonly errors: ReadonlyArray<{
      readonly errorType?: string;
      readonly message?: string;
    }> | null;
    readonly qesSigningResponse: {
      readonly requestId: string;
      readonly signingRequestUrl: any;
    } | null;
  };
};
export type useDeSignTherapyPrescriptionMutation = {
  response: useDeSignTherapyPrescriptionMutation$data;
  variables: useDeSignTherapyPrescriptionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "QesSigningResponse",
  "kind": "LinkedField",
  "name": "qesSigningResponse",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "requestId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "signingRequestUrl",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "errorType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "SignDocumentMutationFailed",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDeSignTherapyPrescriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_signTherapyPrescriptionDocumentPayload",
        "kind": "LinkedField",
        "name": "de_signTherapyPrescriptionDocument",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useDeSignTherapyPrescriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_signTherapyPrescriptionDocumentPayload",
        "kind": "LinkedField",
        "name": "de_signTherapyPrescriptionDocument",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "199e0f4b56ff95d528e0b598ff7d46ea",
    "metadata": {},
    "name": "useDeSignTherapyPrescriptionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "2d810b3a2bb3eb96c9cbfa69880d7c68";

export default node;
